'use client';

import { motion } from 'motion/react';

import { Input } from '@shadCN/ui/input';

const MotionInput: React.FC<React.ComponentProps<'input'>> = props => {
  return (
    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
      <Input {...props} />
    </motion.div>
  );
};

export default MotionInput;
